import { AutoEncoder } from '@simonbackx/simple-encoding';
export class PaymentMandate extends AutoEncoder {
}
//# sourceMappingURL=PaymentMandate.js.map